import React from 'react';
import './App.css';
import { Routes, Route } from 'react-router-dom';
import Home from './view/Home/HomeMain';
import ReminderAppProduct from './view/Products/Reminder/main';
import { RedirectPage } from './view/RedirectPage';
import { CONSTANTS } from './constants/generalConstants';

function App() {
	return (
		<div>
			<Routes>
				<Route path="/">
					<Route index element={<Home />} />
					<Route
						path="reminder-app"
						element={<ReminderAppProduct />}
					/>
					{/* Redirect all other pages to GitHub */}
					<Route path="*" element={<RedirectPage url={CONSTANTS.GITHUB_URL} />} />
				</Route>
			</Routes>
		</div>
	);
}

export default App;
